import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ExpandIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ExpandIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12 22.001C6.48619 22.001 2 17.5148 2 12.001C2 6.48716 6.48619 2.00098 12 2.00098C17.5138 2.00098 22 6.48717 22 12.001C22 17.5148 17.5138 22.001 12 22.001ZM12 3.53567C7.33197 3.53567 3.53471 7.33295 3.53471 12.001C3.53471 16.669 7.33198 20.4663 12 20.4663C16.668 20.4663 20.4653 16.669 20.4653 12.001C20.4653 7.33295 16.668 3.53567 12 3.53567Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.4531 14.4766C15.2612 14.4766 15.0693 14.4033 14.9229 14.2568L12 11.334L9.07716 14.2568C8.78419 14.5498 8.30958 14.5498 8.01661 14.2568C7.72364 13.9639 7.72364 13.4892 8.01661 13.1963L11.4697 9.74316C11.7627 9.45019 12.2373 9.45019 12.5303 9.74316L15.9834 13.1963C16.2764 13.4892 16.2764 13.9639 15.9834 14.2568C15.8369 14.4033 15.645 14.4766 15.4531 14.4766Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ExpandIcon;
